<template>
  <div class="PageSpace m-hp-100 m-fb-col m-hidden m-fb-cross-center">
    <div class="m-hp-100 m-fb m-hidden m-wp-100">
      <iframe
        class="m-hp-100 m-wp-100"
        name="mainIframe"
        src="https://booking.lib.zju.edu.cn"
        frameborder="0"
        scrolling="auto"
      ></iframe>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },

  methods: {}
}
</script>
<style scoped lang="scss"></style>
